/* eslint-disable */
import 'daterangepicker/daterangepicker';
import $ from 'jquery';
import moment from 'moment';
import { getBreakpoints } from '../base/common';
import { updateButtonAvailability } from './daterangepicker-accessibility';

const bookingWidgetForm = document.querySelector('.booking-widget__form');
const labelOpenedClass = 'booking-widget__label--opened';
const labels = document.querySelectorAll('.booking-widget__label');
const submitBtn = document.querySelector('.booking-widget__submit');
const bookingWidgetSelect = document.querySelector('.booking-widget__select');
let $dateRangeSelector;
let picker;
let isSingle;
const chromeAgent = navigator.userAgent.indexOf('Chrome') !== -1;
const bookingAvailabilityDateStatusMap = {};
const loadedDatesResponsesCache = {};
let loadingDates = false;
let lastRequestedDate;

const today = moment();
const tomorrow = moment().add(24, 'hour');

function dateRangeLocale() {
  if (typeof daterangeLocale !== 'undefined') {
    return daterangeLocale;
  }

  return { format: 'MMMM D' };
}

function setBookingAvailabilityDateStatusMapByResponse(hotel, availabilities) {
  availabilities.forEach((availability) => {
    const fromDate = moment(availability.from);
    const toDate = moment(availability.to);
    for (let m = moment(fromDate); m.diff(toDate, 'days') <= 0; m.add(1, 'days')) {
      let status = 'open';
      switch (availability.status) {
        case 'open':
          status = 'open';
          break;
        case 'close':
          status = 'close';
          break;
        case 'closedonarrival':
        case 'minstay':
          status = 'limited';
          break;
      }

      if (!bookingAvailabilityDateStatusMap[hotel]) {
        bookingAvailabilityDateStatusMap[hotel] = [];
      }

      bookingAvailabilityDateStatusMap[hotel][m.format('YYYY-MM-DD')] = status;
    }
  });
}

function loadAvailabilities(hotelCode, from, to, adults, children, callbackOnLoaded) {
  const hotel = hotelCode;
  const url = `${bookingApiBaseUri + hotel}/calendar?from=${from}&to=${to}&adults=${adults}&children=${children}&autoscroll=1&ttl=6`;

  if (loadedDatesResponsesCache[url]) {
    setBookingAvailabilityDateStatusMapByResponse(hotel, loadedDatesResponsesCache[url]);
    return;
  }

  if (loadingDates) {
    return;
  }

  loadingDates = true;
  lastRequestedDate = from;
  $('.c-daterangepicker').addClass('c-daterangepicker--dates-loading');
  $.get(
    url,
    (data) => {
      setBookingAvailabilityDateStatusMapByResponse(hotel, data.availabilities);
      loadedDatesResponsesCache[url] = data.availabilities;
      loadingDates = false;
      $('.c-daterangepicker').removeClass('c-daterangepicker--dates-loading');
      $dateRangeSelector.data('daterangepicker').updateCalendars();
      if (callbackOnLoaded) {
        callbackOnLoaded();
      }
    },
  ).fail((e) => {
    if (e.status === 400) {
      const availabilities = [{
        from,
        to,
        status: 'close',
      }];
      setBookingAvailabilityDateStatusMapByResponse(hotel, availabilities);
      loadedDatesResponsesCache[url] = availabilities;
      loadingDates = false;
      $('.c-daterangepicker').removeClass('c-daterangepicker--dates-loading');
      $dateRangeSelector.data('daterangepicker').updateCalendars();
      if (callbackOnLoaded) {
        callbackOnLoaded();
      }
    } else {
      loadingDates = false;
      initDateRangePicker();
    }
  });
}

function loadAvailabilitiesForCurrentFormState(requestedDate, callbackOnLoaded) {
  if (moment(requestedDate).startOf('month').toDate() < moment().startOf('month').toDate()) {
    return;
  }

  const data = $('.booking-widget__submit').data();
  // 6 days to ignore dates from previous month in the beginning of calendar
  const backDirection = (lastRequestedDate && requestedDate)
    ? moment(lastRequestedDate).subtract(6, 'days').toDate() > moment(requestedDate).toDate() : false;
  const destination = $('#destination').find(':selected');
  const hotel = destination.data('site');

  const adults = 1;
  const children = 0;
  const fromDateMoment = requestedDate
    ? (backDirection ? moment(requestedDate).subtract(3, 'M').startOf('month') : moment(requestedDate).startOf('month'))
    : moment(data.start).startOf('month');
  const fromDate = fromDateMoment.format('YYYY-MM-DD');
  const toDateMoment = fromDateMoment.add(5, 'M').endOf('month');
  const toDate = toDateMoment.format('YYYY-MM-DD');

  loadAvailabilities(
    hotel,
    fromDate,
    toDate,
    adults,
    children,
    callbackOnLoaded,
  );
}

function beforeShowDay(date) {
  const hotel = $('#destination').find(':selected').data('site');
  if (bookingAvailabilityDateStatusMap[hotel] && bookingAvailabilityDateStatusMap[hotel][date.format('YYYY-MM-DD')]) {
    return bookingAvailabilityDateStatusMap[hotel][date.format('YYYY-MM-DD')];
  }

  // ignore possible dates from previous month in the beginning of calendar
  if (lastRequestedDate
    && (date >= moment(lastRequestedDate).subtract(6, 'days').toDate()
      && date < moment(lastRequestedDate))) {
    return false;
  }

  // Load if dates unavailable
  loadAvailabilitiesForCurrentFormState(date.format('YYYY-MM-DD'));
  return false;
}

function initDateRangePicker() {
  picker = $dateRangeSelector.daterangepicker({
    singleDatePicker: isSingle,
    autoUpdateInput: true,
    startDate: today,
    endDate: tomorrow,
    minDate: new Date(),
    opens: 'center',
    locale: dateRangeLocale(),
    isCustomDate: isSingle ? '' : beforeShowDay,
    cancelButtonClasses: 'cancelBtn c-button c-button--underline c-button--gray c-loop-focus__close',
    applyButtonClasses: 'applyBtn c-button c-button--underline c-button--gray',
  }, (pickerStartDate, pickerEndDate) => {
    if (!isSingle) {
      document.querySelector('#arrive').value = pickerStartDate.format('MMMM D');
      document.querySelector('#depart').value = pickerEndDate.format('MMMM D');
    } else {
      document.querySelector('#datetime').value = pickerStartDate.format('MMMM D');
    }
  }).data('daterangepicker');

  picker.container.addClass('c-daterangepicker c-loop-focus');
  picker.container.attr('role', 'dialog');

  $dateRangeSelector.off('focus.daterangepicker');
  $dateRangeSelector.on('hide.daterangepicker', () => {
    labels.forEach((item) => {
      item.classList.remove(labelOpenedClass);
    });
    submitBtn.focus();
  });
  $dateRangeSelector.on('show.daterangepicker', () => {
    if (!isSingle) {
      loadAvailabilitiesForCurrentFormState(null, () => {
        initDateRangePicker();
        $dateRangeSelector.data('daterangepicker').toggle();
      });
    }

    updateButtonAvailability();
    const day = $('.daterangepicker td:not(.off)');
    $(day.get(0)).focus();
  });
  $dateRangeSelector.on('showCalendar.daterangepicker', () => {
    $('.daterangepicker th.available:not(.off), .daterangepicker td.available:not(.off)').attr('tabindex', 0);
    updateButtonAvailability();
    const day = $('.daterangepicker td:not(.off)');
    $(day.get(0)).focus();
  });
}

if (bookingWidgetSelect && chromeAgent) {
  bookingWidgetSelect.addEventListener('focus', function () {
    this.closest('.booking-widget__label').classList.add(labelOpenedClass);
  });
}

$(document).ready(() => {
  if (document.querySelector('#table-widget')) {
    $dateRangeSelector = $('.booking-widget__option-date');
    isSingle = true;
  }

  if (document.querySelector('#room-widget')) {
    $dateRangeSelector = $('.booking-widget__option--daterange');
    isSingle = false;
  }

  initDateRangePicker();

  $('.booking-widget__daterange, .booking-widget__date').on('keypress click', (event) => {
    if ([13, 32].includes(event.which)
      || ((event.type === 'click') && (event.target.classList.contains('booking-widget__daterange') || event.target.classList.contains('booking-widget__date')))
    ) {
      $dateRangeSelector.trigger('click.daterangepicker');
    }

    event.preventDefault();
  });

  $('.booking-widget__select').on('keypress', (event) => {
    if ([13].includes(event.which)) {
      event.preventDefault();
      event.target.showPicker();
    }
  });

  $('body').on('keydown', '.daterangepicker', (e) => {
    if (e.which === 27) {
      $('.daterangepicker .cancelBtn').trigger('click');
    }
  });
});

document.querySelector('.hero__container').addEventListener('click', () => {
  picker.hide();
  labels.forEach((item) => {
    item.classList.remove(labelOpenedClass);
  });
});

document.addEventListener('scroll', () => {
  const scrollTop = $(window).scrollTop();
  const elementOffset = $('body').offset().top;
  const distance = (elementOffset - scrollTop);
  const offset = $('.booking-widget__form').offset().top;

  if (distance < -offset && picker) {
    picker.hide();
  }
});

if (bookingWidgetSelect) {
  bookingWidgetSelect.addEventListener('change', (e) => {
    submitBtn.dataset.restref = e.target.value;
    bookingWidgetForm.action = e.target.querySelector(`option[value="${e.target.value}"]`).dataset.url;
  });
}

if (bookingWidgetForm && submitBtn) {
  bookingWidgetForm.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  submitBtn.addEventListener('click', (e) => {
    const formData = new FormData(bookingWidgetForm);
    const { restref } = e.target.dataset;
    let getParams = {};

    for (const [name, value] of formData.entries()) {
      if (name === 'datetime') {
        getParams[name] = `${picker.startDate.format('YYYY-MM-DD')}T07:00`;
      } else if (name === 'arrive') {
        getParams[name] = picker.startDate.format('MM/DD/YYYY');
      } else if (name === 'depart') {
        getParams[name] = picker.endDate.format('MM/DD/YYYY');
      } else if (name === 'destination') {
        continue;
      } else {
        getParams[name] = value;
      }
    }

    if (restref) {
      getParams.restref = restref;
    }

    getParams = new URLSearchParams(getParams).toString();
    if (((formData.has('destination') && formData.get('destination') === 'palmettobluff') || document.body.dataset.theme === 'palmettobluff') && e.target.closest('#room-widget')) {
      const selectAccommodationTypeButton = document.querySelector('.open-modal[href="#accommodation-type"]');
      const accommodationTypelinks = document.querySelectorAll('.accommodation-type__link');

      if (selectAccommodationTypeButton) {
        for (const link of accommodationTypelinks) {
          link.href = `${link.href.replace(/\?.*/gi, '')}?${getParams}`;
        }

        selectAccommodationTypeButton.click();
        return;
      }
    }

    const desktop = window.innerWidth > getBreakpoints().lg;

    if (document.body.dataset.theme === 'montage' && !desktop) {
      const reservationButton = document.querySelector('#reservation-overlay-corporate-open');
      if (reservationButton) {
        reservationButton.click();
        return;
      }
    }

    if (document.body.dataset.theme === 'big-sky' && e.target.closest('#table-widget')) {
      window.open(`https://www.opentable.com/restref/client/?${getParams}`);
      return;
    }

    if (e.target.closest('#table-widget')) {
      window.open(`${bookingWidgetForm.action}?${getParams}`);
      return;
    }

    if (desktop) {
      window.location.href = `${bookingWidgetForm.action}?${getParams}`;
      return;
    }

    window.location.href = `${bookingWidgetForm.action}`;
  });
}
